/**
 * EU-Gewährleistungsmitteilung – VO (EU) 2025/1960
 * Öffnet/schließt das <dialog>-Overlay aus eu-legal-guarantee-notice.liquid.
 * Funktioniert für beliebig viele Instanzen auf einer Seite
 * (Produktseite, Warenkorb, Cart-Drawer gleichzeitig).
 */
(function () {
  if (window.euLegalNoticeInit) return;
  window.euLegalNoticeInit = true;

  function findDialog(trigger) {
    var wrapper = trigger.closest('.eu-legal-notice');
    return wrapper ? wrapper.querySelector('[data-eu-notice-dialog]') : null;
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-eu-notice-open]');
    if (openTrigger) {
      var dialog = findDialog(openTrigger);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    var closeTrigger = event.target.closest('[data-eu-notice-close]');
    if (closeTrigger) {
      var dlg = closeTrigger.closest('dialog');
      if (dlg) dlg.close();
      return;
    }

    // Klick auf den Backdrop (außerhalb des Inhalts) schließt ebenfalls
    if (event.target.matches('[data-eu-notice-dialog]')) {
      var rect = event.target.getBoundingClientRect();
      var inside =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;
      if (!inside) event.target.close();
    }
  });

  // Esc schließt (nativ durch <dialog> bereits abgedeckt, hier nur
  // zur Sicherheit falls ein Theme das Standardverhalten überschreibt)
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-eu-notice-dialog][open]').forEach(function (dlg) {
      dlg.close();
    });
  });
})();